export default __webpack_public_path__ + "static/media/choose_teams.ec4cddb3.jpg";